import { Serializable } from './Serializable';

export class ParticipationEvolutionDTO extends Serializable {
    month: string;
    participants: number;

    constructor() {
        super();
    }

}
